import React from 'react';
import { Check, UserX } from 'lucide-react';

// Multi-select chips, min 44px tall for tablet use
const CollaboratorPicker = ({ collaborators, value = [], onChange, allowNone = true, compact = false, testIdPrefix = 'collab' }) => {
  const toggle = (id) => {
    onChange(value.includes(id) ? value.filter(v => v !== id) : [...value, id]);
  };
  const size = compact ? 'min-h-[40px] px-3 text-xs' : 'min-h-[44px] px-4 text-sm';
  return (
    <div className="flex flex-wrap gap-2" data-testid={`${testIdPrefix}-picker`}>
      {allowNone && (
        <button type="button" onClick={() => onChange([])}
          className={`${size} rounded-full border-2 font-medium flex items-center gap-1.5 transition-colors ${value.length === 0 ? 'border-gray-800 bg-gray-800 text-white' : 'border-gray-200 text-gray-600 hover:border-gray-400'}`}
          data-testid={`${testIdPrefix}-none`}>
          <UserX size={14} />Non affectée
        </button>
      )}
      {collaborators.map(c => {
        const selected = value.includes(c.id);
        return (
          <button key={c.id} type="button" onClick={() => toggle(c.id)}
            className={`${size} rounded-full border-2 font-medium flex items-center gap-1.5 transition-colors ${selected ? 'border-neon-pink bg-neon-pink/10 text-neon-pink' : 'border-gray-200 text-gray-700 hover:border-gray-400'}`}
            data-testid={`${testIdPrefix}-${c.id}`} aria-pressed={selected}>
            {selected && <Check size={14} strokeWidth={3} />}
            {c.name}
            {!compact && c.station && <span className="text-[10px] text-gray-400 font-normal hidden sm:inline">· {c.station.replace('Poste ', '')}</span>}
          </button>
        );
      })}
    </div>
  );
};

export default CollaboratorPicker;
